/* Layout */
import Layout from "@/views/layout/Layout";

export default [
  {
    path: "/aiChatHistory",
    component: Layout,
    alwaysShow: true,
    meta: {
      title: "AI小谷聊天记录",
      icon: "component"
    },
    children: [
      {
        path: "/aiChatHistory/list",
        component: () => import("@/myviews/shoppMall/aiChatHistory/index.vue"),
        alwaysShow: false,
        hidden: true, // 不是菜单项
        name: "aiChatHistory",
        meta: {
          alwaysShow: false,
          title: "AI小谷聊天记录",
          icon: "component",
          isFullPage: true, // 全屏页面
          have: []
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/shoppMall/aiChat.js